<div class="card card-filter" *ngIf="actualite || displayAucuneActualite">
  <div class="card-header" style="text-align: center; vertical-align: middle">
    <span style="position: absolute; left: 15px">
      <span class="badge badge-pill badge-info" *ngIf="badgeInfo">
        {{ badgeInfo }}
        <span *ngIf="actualite.DebutAffichage"> : le {{ actualite.DebutAffichage | date: 'dd MMMM yyyy' }}</span>
        <span *ngIf="!actualite.DebutAffichage"> : le {{ actualite.Creation | date: 'dd MMMM yyyy' }}</span>
      </span>
    </span>
    <h1 style="margin: 0 110px; font-weight: bold; font-size: 16px" *ngIf="actualite">{{ actualite.Libelle }}</h1>
  </div>
  <div class="card-body" style="padding: 0.5rem 1.25rem 0 1.25rem">
    <div *ngIf="actualite" class="form-group">
      <div class="form-group row" style="text-align: center; vertical-align: middle" *ngIf="actualite.LogoUrl">
        <div class="col-sm-12">
          <img src="{{ actualite.LogoUrl }}" style="max-height: 400px; max-width: 500px" />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-12" style="margin-right: 5px; line-height: 1.5">
          <read-more-html [content]="actualite.Contenu" [maxHeight]="190"></read-more-html>
        </div>
      </div>
    </div>
    <div *ngIf="!actualite && displayAucuneActualite && actualiteLoaded" class="form-group row col-sm-12" style="margin-bottom: 25px">
      <span>Aucune actualité pour le moment</span>
    </div>
  </div>
</div>
